import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DesktopSelectedSubjects from "../components/DesktopSelectedSubjects/DesktopSelectedSubjects";
import { useTranslatedText } from "../contexts/TranslationContext";

const MobileCursos = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const subjectHeader = useTranslatedText("Materia", { capitalize: true });
  const unsubscribeHeader = useTranslatedText("Desinscripción", { capitalize: true });

  useEffect(() => {
    if (!token) {
      localStorage.clear()
      sessionStorage.clear();
      navigate("/login");
    }
  }, []);

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", gap: "6px" }}>
      <div className="mobile-cursos-box">
        <div className="mobile-theader-cursos">
          <h5>{subjectHeader}</h5>
          <h5>{unsubscribeHeader}</h5>
        </div>
        <DesktopSelectedSubjects />
      </div>
    </div>
  );
};

export default MobileCursos;
